import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const createFaqEngagement: ApiMethod<
  Server.UserFaqEngagementInput,
  number
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);

    const response = await client.faqs_helpful_post_V1(data);

    rejectWithValue(response.errors);

    return data.faqId;
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;

    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    rejectWithValue(error);

    return data.faqId;
  }
};

export const getCategoryFaqs: ApiMethod<
  {
    Id: number;
    PageNumber: number;
    PageSize: number;
  },
  {
    [key: string]: {
      data: Server.FaqOutput[];
      meta: {
        hasNextPage: boolean | undefined;
        currentPage: number | undefined;
        totalCount: number | undefined;
      };
    };
  }
> = async (data, { dispatch, rejectWithValue }) => {
  const { Id, PageNumber, PageSize } = data;

  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);

    const response = await client.faqs_categories_faqs_get_V1(
      undefined,
      Id,
      PageNumber,
      PageSize
    );
    if (response.success && response.data) {
      const { hasNextPage, currentPage, totalCount, data } = response;

      return {
        [Id]: {
          data,
          meta: { hasNextPage, currentPage, totalCount },
        },
      };
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );

    return rejectWithValue(error);
  }
};

export const getFaqsDataTable: ApiMethod<
  Server.FaqsDatatable,
  Server.TableOfFaqColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_datatable_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createNewFaq: ApiMethod<
  Server.CreateFaqInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const editFaq: ApiMethod<Server.UpdateFaqInput, number, any> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_put_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getFaqById: ApiMethod<
  number,
  Server.FaqWithCategoryOutput,
  any
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_byId_get_V1(undefined, id);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const deleteFaq: ApiMethod<number, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_Id_delete_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const getFaqCtegories: ApiMethod<
  void,
  Server.CategoryOutput[],
  any
> = async (_, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_categories_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createNewCategory: ApiMethod<
  Server.CreateCategoryInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_categories_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const editCategory: ApiMethod<
  Server.UpdateCategoryInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_categories_put_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
export const deleteCategory: ApiMethod<number, void, any> = async (
  id,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Faqs_Client(undefined, identityClient);
    const response = await client.faqs_categories_Id_delete_V1(id);
    if (response.success) {
      return;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
